import { gql } from "@/api/utils.js"
const fetchCategories = gql`
	query courses($where: courseWhereInput) {
		courses(where: $where) {
			list {
				categories
			}
		}
	}
`

const fetchCourse = gql`
	query courses(
		$limit: Int
		$skip: Int
		$sort: sortInput
		$where: courseWhereInput
	) {
		courses(where: $where, skip: $skip, sort: $sort, limit: $limit) {
			totalCount
			list {
				id
				name
				description
				version
				categories
				sections {
					id
					name
					description
					lessons {
						...lessonFields
					}
					sections {
						id
						name
						description
						lessons {
							...lessonFields
						}
						sections {
							id
							name
							description
							lessons {
								...lessonFields
							}
						}
					}
				}
			}
		}
	}

	fragment lessonFields on lesson {
		id
		name
		description
		version
		passingRatio
		weight
		durationInSeconds
		items {
			id
			type
			localizedContent
			options {
				id
				localizedContent
				isCorrect
			}
		}
	}
`

const fetchCourses = gql`
	query courses($where: courseWhereInput) {
		courses(where: $where) {
			list {
				id
				name
				description
				createdAt
				categories
				version
				sections {
					lessons {
						durationInSeconds
					}
					sections {
						sections {
							lessons {
								durationInSeconds
							}
						}
						lessons {
							durationInSeconds
						}
					}
				}
			}
		}
	}
`

const createCourse = gql`
	mutation createCourse($input: createCourseInput!) {
		createCourse(input: $input) {
			createdStatus {
				id
			}
			errors
			status
		}
	}
`

const updateCourse = gql`
	mutation updateCourse($id: String!, $input: updateCourseInput!) {
		updateCourse(input: $input, id: $id) {
			errors
			status
		}
	}
`

const deleteCourse = gql`
	mutation removeCourse($id: String!) {
		deleteCourse(id: $id) {
			errors
			status
		}
	}
`

const upsertL10n = gql`
	mutation upsertL10n($l10n: upsertL10nInput) {
		upsertL10n(l10n: $l10n) {
			status
			errors
		}
	}
`

const deleteAllL10n = gql`
	mutation deleteAllL10n($key: String!) {
		deleteAllL10n(key: $key) {
			errors
			status
		}
	}
`

const addSectionToCourse = gql`
	mutation addSectionToCourse($courseId: String!) {
		addSectionToCourse(courseId: $courseId) {
			createdStatus {
				id
			}
			errors
			status
		}
	}
`

const removeSectionFromCourse = gql`
	mutation removeSectionFromCourse($courseId: String!, $sectionId: String!) {
		removeSectionFromCourse(courseId: $courseId, sectionId: $sectionId) {
			errors
			status
		}
	}
`

const addSectionToSection = gql`
	mutation addSectionToSection($courseId: String!, $sectionId: String!) {
		addSectionToSection(courseId: $courseId, sectionId: $sectionId) {
			createdStatus {
				id
			}
			errors
			status
		}
	}
`

const addLessonToSection = gql`
	mutation addLessonToSection(
		$courseId: String!
		$sectionId: String!
		$input: addLessonToSectionInput
	) {
		addLessonToSection(
			courseId: $courseId
			sectionId: $sectionId
			input: $input
		) {
			createdStatus {
				id
			}
			status
			errors
		}
	}
`

const updateLessonOfSection = gql`
	mutation updateLessonOfSection(
		$courseId: String!
		$sectionId: String!
		$lessonId: String!
		$input: updateLessonOfSectionInput!
	) {
		updateLessonOfSection(
			courseId: $courseId
			sectionId: $sectionId
			lessonId: $lessonId
			input: $input
		) {
			status
			errors
		}
	}
`

const removeLessonFromSection = gql`
	mutation removeLessonFromSection(
		$courseId: String!
		$sectionId: String!
		$lessonId: String!
	) {
		removeLessonFromSection(
			courseId: $courseId
			sectionId: $sectionId
			lessonId: $lessonId
		) {
			errors
			status
		}
	}
`

const addLessonItem = gql`
	mutation addItem(
		$courseId: String!
		$lessonId: String!
		$input: addLessonItemInput!
	) {
		addLessonItem(courseId: $courseId, lessonId: $lessonId, input: $input) {
			createdStatus {
				id
			}
			status
			errors
		}
	}
`

const updateLessonItem = gql`
	mutation UpdateItem(
		$courseId: String!
		$lessonId: String!
		$itemId: String!
		$input: updateLessonItemInput!
	) {
		updateLessonItem(
			courseId: $courseId
			lessonId: $lessonId
			itemId: $itemId
			input: $input
		) {
			status
			errors
		}
	}
`

const removeLessonItem = gql`
	mutation removeItem(
		$courseId: String!
		$lessonId: String!
		$itemId: String!
	) {
		removeLessonItem(
			courseId: $courseId
			lessonId: $lessonId
			itemId: $itemId
		) {
			status
			errors
		}
	}
`

const addOptionToLessonItem = gql`
	mutation addOptionToLessonItem(
		$courseId: String!
		$lessonId: String!
		$itemId: String!
		$input: addOptionToLessonItemInput!
	) {
		addOptionToLessonItem(
			courseId: $courseId
			lessonId: $lessonId
			itemId: $itemId
			input: $input
		) {
			createdStatus {
				id
			}
			status
			errors
		}
	}
`

const updateOptionOfLessonItem = gql`
	mutation updateOptionOfLessonItem(
		$courseId: String!
		$lessonId: String!
		$itemId: String!
		$optionId: String!
		$input: updateOptionOfLessonItemInput!
	) {
		updateOptionOfLessonItem(
			courseId: $courseId
			lessonId: $lessonId
			itemId: $itemId
			optionId: $optionId
			input: $input
		) {
			status
			errors
		}
	}
`

const removeOptionFromLessonItem = gql`
	mutation removeOptionFromLessonItem(
		$courseId: String!
		$lessonId: String!
		$itemId: String!
		$optionId: String!
	) {
		removeOptionFromLessonItem(
			courseId: $courseId
			lessonId: $lessonId
			itemId: $itemId
			optionId: $optionId
		) {
			errors
			status
		}
	}
`

export default {
	fetchCategories,
	fetchCourses,
	fetchCourse,
	createCourse,
	deleteCourse,
	updateCourse,
	upsertL10n,
	deleteAllL10n,
	addSectionToCourse,
	removeSectionFromCourse,
	addSectionToSection,
	addLessonToSection,
	updateLessonOfSection,
	removeLessonFromSection,
	addLessonItem,
	updateLessonItem,
	removeLessonItem,
	addOptionToLessonItem,
	updateOptionOfLessonItem,
	removeOptionFromLessonItem
}
